<template>
<div class="chapter">
<div class="inner_page">
<p class="ded"><a id="page_ix"> To the loves of my life, Sarah, Chase, and Olivia.</a></p><a id="page_ix">
<p class="ded1">To my parents, John (“Jack”) and Barbara.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?12a94398